import { useAuth0 } from "@auth0/auth0-react";
import Page from "ui/Page";


export default function Home() {
	const auth0 = useAuth0();

	console.log(auth0);

	return (
		<Page>
			<Page.Header title="Home" />
			<Page.Body>
				Imagine a beautiful home page here
			</Page.Body>
		</Page>
	);
}